export async function PostSugeriment(userId: string, text: string, anonim: boolean) {
    const url = `${process.env.REACT_APP_API_URL}:8061/usuaris/sugeriments`;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id_usuari: userId, text: text, anonim: anonim })
        });

        return response.ok;
    } catch (e) {
        console.error("PostSugeriment error:", e);
        return false;
    }
}
